import { Injectable } from '@angular/core';


import { select, NgRedux } from '@angular-redux/store';

import { NotificationActions } from '../actions/notification.actions';
import { CoreState } from '../store/core.store';
import { NOTIFICATION_ROLES, NOTIFICATION_TYPES } from './../enums/notifications.enum';
import { Notification } from './../ridango.models';
import { LogService } from './log.service';
@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private notificationQueue: Notification[] = [];
    @select(['core', 'notifications']) notifications$?;

    constructor(private ngRedux: NgRedux<CoreState>, private actions: NotificationActions, private ls: LogService) {}

    get notificationTypes() {
        return NOTIFICATION_TYPES;
    }

    add(notification: Notification, group = false): void {
        if (group) {
            this.ngRedux.dispatch(this.actions.addGroupedNotification(notification));
        } else {
            this.ngRedux.dispatch(this.actions.addNotification(notification));
        }
    }
    deleteAll(source: any = null, f: any = null) {
        if (source) {
            this.ls.log(this, 'deleteAll', [source.constructor.name, f]);
        }
        this.ngRedux.dispatch(this.actions.removeAllNotifications());
    }
    delete(notification: Notification) {}

    addNotification(notification: Notification) {
        this.add(notification);
    }

    addNotificationToQueue(notification: Notification) {
        notification.role = NOTIFICATION_ROLES.ALERT;
        this.notificationQueue.push(notification);
    }

    displayNotifications() {
        this.deleteAll();
        this.notificationQueue.forEach((noti) => {
            this.add(noti);
        });
        this.notificationQueue = [];
    }

}
